import { combineReducers } from 'redux';
import { AddFiles } from './addFiles';
import { ServicesList } from './addServices';
import { AddFilesList } from './addFilesList';
import { UserData } from './addUserData';

export default combineReducers({
    AddFiles,
    ServicesList,
    AddFilesList,
    UserData
});
